import { render, staticRenderFns } from "./ModalImportarContrato.vue?vue&type=template&id=2b0bc409&scoped=true"
import script from "./ModalImportarContrato.vue?vue&type=script&lang=ts"
export * from "./ModalImportarContrato.vue?vue&type=script&lang=ts"
import style0 from "./ModalImportarContrato.vue?vue&type=style&index=0&id=2b0bc409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc409",
  null
  
)

export default component.exports